export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    year = "",
    accountNumber = "",
    warehouseName = "",
    itemName = "",
    itemUnit = "",
    details = [],
    totalPages = "",
    openingDate = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let totalInwardAmount = 0;
  let totalOutwardAmount = 0;

  let tableRows = details.map((item) => {
    totalInwardAmount += parseFloat(item.inwardAmount) || 0;
    totalOutwardAmount += parseFloat(item.outwardAmount) || 0;

    return `
      <tr>
        <td class="border text-center">${item.docNumber || ""}</td>
        <td class="border text-center">${item.docDate || ""}</td>
        <td class="border px-1">${item.description || ""}</td>
        <td class="border text-center">${item.offsetAccount || ""}</td>
        <td class="border text-right px-1">${fmt(item.unitPrice)}</td>
        <td class="border text-right px-1">${fmt(item.inwardQuantity)}</td>
        <td class="border text-right px-1">${fmt(item.inwardAmount)}</td>
        <td class="border text-right px-1">${fmt(item.outwardQuantity)}</td>
        <td class="border text-right px-1">${fmt(item.outwardAmount)}</td>
        <td class="border text-right px-1 font-bold bg-light">${fmt(item.balanceQuantity)}</td>
        <td class="border text-right px-1 font-bold bg-light">${fmt(item.balanceAmount)}</td>
        <td class="border px-1">${item.note || ""}</td>
      </tr>
    `;
  }).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 11px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="30%" valign="top">
            <div class="font-bold">Đơn vị: <span class="dotted-line">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span class="dotted-line">${address}</span></div>
          </td>
          <td width="70%" align="center">
            <div class="font-bold">Mẫu số S10-DN</div>
            <div style="font-style: italic; font-size: 10px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 15px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 16px;">SỔ CHI TIẾT VẬT LIỆU, DỤNG CỤ (SẢN PHẨM, HÀNG HÓA)</h2>
        <div style="margin-top: 5px; font-weight: bold;">Năm: ${year}</div>
        <div style="margin-top: 5px; font-weight: bold;">
          Tài khoản: <span class="dotted-line px-1">${accountNumber}</span>
          Tên kho: <span class="dotted-line px-1">${warehouseName}</span>
        </div>
      </div>

      <table width="100%">
        <tr>
          <td width="80%">
             Tên, quy cách nguyên liệu, vật liệu, công cụ, dụng cụ (sản phẩm, hàng hóa): <span class="dotted-line">${itemName}</span>
          </td>
          <td width="20%" align="right" style="font-style: italic;">
             Đơn vị tính: <span class="dotted-line" style="font-style: normal;">${itemUnit}</span>
          </td>
        </tr>
      </table>

      <table class="table-full" width="100%" style="border-collapse: collapse; margin-top: 10px;">
        <thead>
          <tr>
            <th class="border" colspan="2" width="100">Chứng từ</th>
            <th class="border" rowspan="2">Diễn giải</th>
            <th class="border" rowspan="2" width="60">Tài khoản đối ứng</th>
            <th class="border" rowspan="2" width="70">Đơn giá</th>
            <th class="border" colspan="2">Nhập</th>
            <th class="border" colspan="2">Xuất</th>
            <th class="border" colspan="2">Tồn</th>
            <th class="border" rowspan="2" width="80">Ghi chú</th>
          </tr>
          <tr>
            <th class="border" width="50">Số hiệu</th>
            <th class="border" width="50">Ngày, tháng</th>
            <th class="border" width="60">Số lượng</th>
            <th class="border" width="80">Thành tiền</th>
            <th class="border" width="60">Số lượng</th>
            <th class="border" width="80">Thành tiền</th>
            <th class="border" width="60">Số lượng</th>
            <th class="border" width="80">Thành tiền</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3=1x2</th>
            <th class="border">4</th>
            <th class="border">5=1x4</th>
            <th class="border">6</th>
            <th class="border">7=(1x6)</th>
            <th class="border">8</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
          <tr style="font-weight: bold; background-color: #fafafa;">
            <td class="border" colspan="2"></td>
            <td class="border text-center" colspan="2">Cộng tháng</td>
            <td class="border text-center">X</td>
            <td class="border"></td>
            <td class="border text-right px-1">${fmt(totalInwardAmount)}</td>
            <td class="border"></td>
            <td class="border text-right px-1">${fmt(totalOutwardAmount)}</td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top: 15px;">
        <div>- Sổ này có <span class="dotted-line">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <span class="dotted-line">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 20px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 50px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 50px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 11px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 50px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 4px; }
        .bg-light { background-color: #fdfdfd; }
        .table-full { border: 1px solid black; }
        .dotted-line { border-bottom: 1px dotted black; }
      </style>
    </div>
  `;
};
